<template>
    <div class="note-with-fingering">
        <div class="note-display">
            <MusicNote
                :note="note"
                :clef="clef"
                :duration="duration"
                :width="noteWidth"
                :height="noteHeight"
            />
        </div>
        <div class="fingering-display">
            <FluteFingering
                :note="showNoteLabel ? note : undefined"
                :fingering="fingering"
                :width="fingeringWidth"
                :height="fingeringHeight"
                orientation="horizontal"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import MusicNote from "./MusicNote.vue";
import FluteFingering from "./FluteFingering.vue";
import { getStandardFingering, type FingeringState } from "../data/fluteFingeringChart";

interface Props {
    note?: string;
    clef?: string;
    duration?: string;
    noteWidth?: number;
    noteHeight?: number;
    fingeringWidth?: number;
    fingeringHeight?: number;
    fingering?: FingeringState;
    showNoteLabel?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    note: "C5",
    clef: "treble",
    duration: "quarter",
    noteWidth: 200,
    noteHeight: 120,
    fingeringWidth: 500,
    fingeringHeight: 180,
    showNoteLabel: true,
});

// Get fingering from props or use standard fingering for the note
const fingering = computed(() => {
    if (props.fingering) {
        return props.fingering;
    }
    return getStandardFingering(props.note || "C5") || {};
});
</script>

<style scoped>
.note-with-fingering {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    padding: 12px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.note-display {
    display: flex;
    justify-content: center;
}

.fingering-display {
    display: flex;
    justify-content: center;
}
</style>
